import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    untitled: 'Без названия',
    loading: 'Загрузка…',
    noCourses: 'Курсов нет',
    noArticles: 'Инструкций нет',
    colName: 'Название',
    colAuthors: 'Авторы',
    colAuthor: 'Автор',
    colStatus: 'Статус',
    colAccess: 'Доступ',
    colUpdated: 'Обновлено',
    published: 'Опубликован',
    draft: 'Черновик',
    linkOnly: 'Только по ссылке',
    deleted: 'Удалено',
    accessPrivate: 'Закрытый',
    accessLink: 'По ссылке',
    accessPublic: 'В каталоге',
    moderation: 'Модерация',
    moderationHint: 'Управление курсами и инструкциями всех авторов',
    tabArticles: 'Инструкции',
    tabCourses: 'Курсы',
    noAccess: 'Нет доступа',
    noAccessHint:
      'Эта страница доступна только администраторам. Если вам нужен доступ, напишите команде.',
    toHome: 'На главную',
  },
  en: {
    untitled: 'Untitled',
    loading: 'Loading…',
    noCourses: 'No courses',
    noArticles: 'No articles',
    colName: 'Title',
    colAuthors: 'Authors',
    colAuthor: 'Author',
    colStatus: 'Status',
    colAccess: 'Access',
    colUpdated: 'Updated',
    published: 'Published',
    draft: 'Draft',
    linkOnly: 'By link only',
    deleted: 'Deleted',
    accessPrivate: 'Private',
    accessLink: 'By link',
    accessPublic: 'In catalog',
    moderation: 'Moderation',
    moderationHint: 'Manage courses and articles from all authors',
    tabArticles: 'Articles',
    tabCourses: 'Courses',
    noAccess: 'No access',
    noAccessHint:
      'This page is available to administrators only. If you need access, contact the team.',
    toHome: 'Back to home',
  },
})
